module.exports = __webpack_public_path__ + "img/文件2.6d99ad56.png";